import React from 'react'
import { VariantOptionProps } from '@storefronts/common-types'
import { Tab } from '../../styled/variantComponents'

type TextVariantOptionProps = Pick<
    VariantOptionProps,
    'value' | 'isSelected' | 'isAvailable' | 'onClick'
> & {
    isClickable?: boolean
}

export const TextVariantOption: React.FC<TextVariantOptionProps> = ({
    value,
    isSelected: isActive,
    isAvailable,
    isClickable = true,
    onClick: onSelect,
}) => {
    return (
        <Tab
            active={isActive}
            available={isAvailable}
            isClickable={isClickable}
            onClick={onSelect}
            role="radio"
            aria-checked={isActive}
            aria-disabled={!isClickable}
            data-testid={`text-variant-${value}`}
        >
            {value}
        </Tab>
    )
}
